import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import map from 'lodash/map';
import classnames from 'classnames';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Tabs, Tab } from '@material-ui/core';

import messages from 'containers/Main/messages';

const styles = createStyles({
  selected: {},
  tabLabelContainer: {
    padding: '6px 0px',
  },
  tab: {
    background: '#edf5f8',
    flex: 1,
    fontSize: 14,
    margin: '0px 2px',
    minWidth: 50,
    '&$selected': {
      background: 'white',
    },
    outline: 'none !important',
  },
  tabs: {
    background: 'white',
  },
});

class MainTabs extends React.PureComponent {
  constructor(props) {
    super(props);
    this.renderTab = this.renderTab.bind(this);
  }

  render() {
    const { classes, tabs, tab, onTabChange } = this.props;
    return (
      <Tabs
        classes={{ root: classes.tabs }}
        onChange={(_, value) => onTabChange(value)}
        value={tab}
        variant="fullWidth"
      >
        {map(tabs, this.renderTab)}
      </Tabs>
    );
  }

  renderTab(key) {
    const { classes, tab } = this.props;

    return (
      <Tab
        classes={{
          root: classnames(classes.tab, { [classes.selected]: key === tab }),
          labelContainer: classes.tabLabelContainer,
        }}
        key={key}
        value={key}
        label={<FormattedMessage {...messages[key]} />}
      />
    );
  }
}

MainTabs.propTypes = {
  classes: PropTypes.object.isRequired,
  tabs: PropTypes.array.isRequired,
  tab: PropTypes.string,
  onTabChange: PropTypes.func.isRequired,
};

export default withStyles(styles)(MainTabs);
